import {React,useRef,useState,useEffect} from 'react';
import { Link ,useNavigate} from "react-router-dom";
import { Tooltip } from "antd";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Tabs, Card, Row, Col, Typography, Badge, Button, Table, Alert ,message,Spin  } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import axios from "axios";
import Swal from "sweetalert2";
import ViewSalaryModal from "../../../pages/HR/Payroll/components/ViewSalaryDetails";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "sheetjs-style";
import { FileText, File } from "react-feather";
import html2pdf from 'html2pdf.js';

const PayrollPage = () => {

  const [payrollData, setPayrollData] = useState(null);
  const [employees, setEmployees] = useState([]);
  const navigate = useNavigate();
  const { TabPane } = Tabs;
  const { Title, Text } = Typography;
  const maximizeBtnRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleCloseModal = () => setIsModalVisible(false);


  const generateSalarySlip = (employee) => {
    if (!employee || !employee.salary_breakdown) {
      console.error("Employee data or salary breakdown is missing.");
      return;
    }
  
    const monthYear = moment(employee.payroll_month, "MM-YYYY").isValid()
      ? moment(employee.payroll_month, "MM-YYYY").format("MMMM YYYY")
      : "Invalid Date";
  
    const totalEarnings = employee.salary_breakdown.earnings.reduce(
      (sum, item) => sum + (item.amount || 0),
      0
    );
    const totalDeductions = employee.salary_breakdown.deductions.reduce(
      (sum, item) => sum + (item.amount || 0),
      0
    );
    const netPay = totalEarnings - totalDeductions;
  
    const earningsRows = employee.salary_breakdown.earnings
      .map(
        (earning) => `
        <tr>
          <td>${earning.head || "N/A"}</td>
          <td>${earning.full || earning.amount || "0"}</td>
          <td>${earning.amount || "0"}</td>
        </tr>`
      )
      .join("");
  
    const deductionsRows = employee.salary_breakdown.deductions
      .map(
        (deduction) => `
        <tr>
          <td>${deduction.head || "N/A"}</td>
          <td>${deduction.amount || "0"}</td>
        </tr>`
      )
      .join("");
  
    const salarySlipHTML = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Salary Slip</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f5f5f5;
          }
          .salary_slip {
            width: 210mm;
            height: 297mm; /* A4 size */
            margin: 0 auto;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #ddd;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }
          .salary_header {
            text-align: center;
            margin-bottom: 20px;
          }
          .salary_header img {
            width: 250px;
            height: 110px;
          }
          .salary_header h1 {
            margin: 5px 0;
            font-size: 20px;
            text-transform: uppercase;
          }
          .salary_details {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          .salary_details td {
            padding: 5px;
            border: 1px solid #ddd;
          }
          .salary_details .salary_left {
            font-weight: bold;
          }
          .salary_earnings_deductions {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          .salary_earnings_deductions th, .salary_earnings_deductions td {
            padding: 8px;
            border: 1px solid #ddd;
            text-align: center;
          }
          .salary_earnings_deductions th {
            background-color: #f0f0f0;
          }
          .salary_summary {
            text-align: right;
            font-size: 16px;
            margin-bottom: 10px;
          }
          .salary_footer {
            text-align: center;
            font-size: 12px;
            color: #666;
          }
          @media print {
            .salary_slip {
              box-shadow: none;
              margin: 0;
              padding: 10mm;
              border: none;
            }
          }
        </style>
      </head>
      <body>
        <div class="salary_slip">
          <div class="salary_header">
            <img src="logo.png" alt="Company Logo">
            <h1>Company Name</h1>
            <h2>Payslip for the month of ${monthYear}</h2>
          </div>
  
          <table class="salary_details">
            <tr>
              <td class="salary_left">Name:</td>
              <td>${employee.name || "N/A"}</td>
              <td class="salary_left">Employee ID:</td>
              <td>${employee.empcode || "N/A"}</td>
            </tr>
            <tr>
              <td class="salary_left">Department:</td>
              <td>${employee.department_name || "N/A"}</td>
              <td class="salary_left">Designation:</td>
              <td>${employee.designation_name || "N/A"}</td>
            </tr>
          </table>
  
          <table class="salary_earnings_deductions">
            <thead>
              <tr>
                <th>Earnings</th>
                <th>Full</th>
                <th>Actual</th>
                <th>Deductions</th>
                <th>Actual</th>
              </tr>
            </thead>
            <tbody>
              ${earningsRows}
              ${deductionsRows}
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2"><strong>Total Earnings:</strong></td>
                <td>${totalEarnings.toLocaleString("en-IN")}</td>
                <td><strong>Total Deductions:</strong></td>
                <td>${totalDeductions.toLocaleString("en-IN")}</td>
              </tr>
            </tfoot>
          </table>
  
          <div class="salary_summary">
            <p><strong>Net Pay for the month: ₹${netPay.toLocaleString("en-IN")}</strong></p>
          </div>
  
          <div class="salary_footer">
            <p>This is a system-generated payslip and does not require a signature.</p>
          </div>
        </div>
      </body>
      </html>
    `;
  
    const element = document.createElement("div");
    element.innerHTML = salarySlipHTML;
  
    const options = {
      margin: 0.5,
      filename: `Salary_Slip_${employee.name}_${monthYear}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
  
    html2pdf().set(options).from(element).save();
  };
     
  
  
  
  
  
   

  const handleExportToExcel = () => {
    if (!payrollData || !payrollData.employees) {
      console.error("No payroll data available for export.");
      return;
    }

    const workbook = XLSX.utils.book_new();
    const companyName = "XYZ Company Name";
    const currentDate = moment().format("DD MMMM YYYY");
    const payrollMonthYear = payrollData.payroll?.payroll_month
      ? moment(payrollData.payroll.payroll_month, "MM-YYYY").format("MMMM YYYY")
      : "N/A";
    const payrollStatus = payrollData.payroll?.payroll_status?.toUpperCase() || "N/A";

    const sheetHeading = `Employee Salary for the Month of ${payrollMonthYear} (${payrollStatus})`;

    // Header rows
    const headerData = [
      [`${companyName}`], // Company name
      [`${sheetHeading}`], // Title with month and status
      [`Date Generated: ${currentDate}`], // Date of generation
      [
        "Employee Name",
        "Employee Code",
        "Department",
        "Designation",
        "Gross Salary",
        "Deductions",
        "Net Pay",
      ], // Table headers
    ];

    // Populate table rows
    const tableBody = payrollData.employees.map((employee) => [
      employee.name,
      employee.empcode,
      employee.department_name || "N/A",
      employee.designation_name || "N/A",
      `₹${(employee.gross_salary || 0).toLocaleString("en-IN")}`,
      `₹${(employee.deductions || 0).toLocaleString("en-IN")}`,
      `₹${((employee.gross_salary || 0) - (employee.deductions || 0)).toLocaleString("en-IN")}`,
    ]);

    // Calculate totals
    const totalGross = payrollData.employees.reduce(
      (sum, employee) => sum + (employee.gross_salary || 0),
      0
    );
    const totalDeductions = payrollData.employees.reduce(
      (sum, employee) => sum + (employee.deductions || 0),
      0
    );
    const totalNetPay = payrollData.employees.reduce(
      (sum, employee) =>
        sum + ((employee.gross_salary || 0) - (employee.deductions || 0)),
      0
    );

    // Add totals row
    tableBody.push([]);
    tableBody.push([
      "TOTAL",
      "",
      "",
      "",
      `₹${totalGross.toLocaleString("en-IN")}`,
      `₹${totalDeductions.toLocaleString("en-IN")}`,
      `₹${totalNetPay.toLocaleString("en-IN")}`,
    ]);

    // Combine headers and table data
    const sheetData = [...headerData, ...tableBody];

    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Merge and style the header rows
    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // Merge company name
      { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } }, // Merge sheet heading
      { s: { r: 2, c: 0 }, e: { r: 2, c: 6 } }, // Merge date generated
    ];

    // Set column widths
    worksheet["!cols"] = [
      { wch: 30 }, // Employee Name
      { wch: 15 }, // Employee Code
      { wch: 20 }, // Department
      { wch: 20 }, // Designation
      { wch: 15 }, // Gross Salary
      { wch: 15 }, // Deductions
      { wch: 15 }, // Net Pay
    ];

    // Apply styles
    Object.keys(worksheet).forEach((cellAddress) => {
      if (!cellAddress.startsWith("!")) {
        worksheet[cellAddress].s = {
          font: { name: "Arial", sz: 10 },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    });

    // Bold and larger font for headers
    ["A1", "A2", "A3"].forEach((cell) => {
      if (worksheet[cell]) {
        worksheet[cell].s = {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center", vertical: "center" },
        };
      }
    });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Salary");

    // Export workbook
    XLSX.writeFile(workbook, `Employee_Salary_Report_${moment().format("YYYYMMDD")}.xlsx`);

};



  const handleExportToPDF = () => {
    if (!payrollData || !payrollData.employees) {
      console.error("No payroll data available for export.");
      return;
    }

    const doc = new jsPDF();

    const companyName = "XYZ Company Name";
    const currentDate = moment().format("DD MMMM YYYY");
    const payrollMonthYear = payrollData.payroll?.payroll_month
      ? moment(payrollData.payroll.payroll_month, "MM-YYYY").format("MMMM YYYY")
      : "N/A";
    const payrollStatus = payrollData.payroll?.payroll_status?.toUpperCase() || "N/A";

    const sheetHeading = `Employee Salary for the Month of ${payrollMonthYear} (${payrollStatus})`;

    // Add Company Name
    doc.setFontSize(18);
    doc.text(companyName, 105, 20, { align: "center" });

    // Add Heading
    doc.setFontSize(14);
    doc.text(sheetHeading, 105, 30, { align: "center" });

    // Add Date Generated
    doc.setFontSize(12);
    doc.text(`Date Generated: ${currentDate}`, 105, 40, { align: "center" });

    // Prepare table data
    const tableColumnHeaders = [
      "Employee Name",
      "Employee Code",
      "Gross Salary",
      "Deduction",
      "LOP Days",
      "Net Pay",
      "Status",
    ];

    const tableBodyData = payrollData.employees.map((employee) => [
      employee.name,
      employee.empcode,
      `₹${(employee.gross_salary || 0).toLocaleString("en-IN")}`,
      `₹${(employee.deductions || 0).toLocaleString("en-IN")}`,
      `₹${((employee.gross_salary || 0) - (employee.deductions || 0)).toLocaleString("en-IN")}`,
      employee.payroll_status,
      employee.payment_date,

    ]);

    // Calculate totals
    const totalGross = payrollData.employees.reduce(
      (sum, employee) => sum + (employee.gross_salary || 0),
      0
    );
    const totalDeductions = payrollData.employees.reduce(
      (sum, employee) => sum + (employee.deductions || 0),
      0
    );
    const totalNetPay = payrollData.employees.reduce(
      (sum, employee) =>
        sum + ((employee.gross_salary || 0) - (employee.deductions || 0)),
      0
    );

    // Add Totals Row
    tableBodyData.push([]);
    tableBodyData.push([
      "TOTAL",
      "",
      `₹${totalGross.toLocaleString("en-IN")}`,
      `₹${totalDeductions.toLocaleString("en-IN")}`,
      `₹${totalNetPay.toLocaleString("en-IN")}`,
    ]);

    // Generate table
    doc.autoTable({
      startY: 50,
      head: [tableColumnHeaders],
      body: tableBodyData,
      theme: "grid", // Grid theme for full borders
      styles: {
        fontSize: 8, // Small font size
        halign: "center", // Center align all content
        valign: "middle", // Vertically center align all content
        cellPadding: 2, // Reduce padding for a compact table
      },
      headStyles: {
        fillColor: [0, 123, 255], // Blue header background
        textColor: [255, 255, 255], // White text
        fontStyle: "bold", // Bold text in header
        fontSize: 10, // Slightly larger font for headers
      },
      bodyStyles: {
        fillColor: [245, 245, 245], // Light gray background for rows
        textColor: [50, 50, 50], // Dark gray text
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255], // White background for alternate rows
      },
    });
    

    // Save the PDF
    doc.save(`Employee_Salary_Report_${moment().format("YYYYMMDD")}.pdf`);
  };

   // Fetch Payroll Details 
 // Table Columns
 const columns = [
  {
    title: 'Employee Name',
    dataIndex: 'name',
  key: 'name',
    render: (text, record) => (

    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Tooltip
          title={
            parseInt(record.is_skipped, 10) === 1
              ? record.skipped_reason || "Skipped from payroll"
              : "Included in payroll"
          }
          placement="top"
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: parseInt(record.is_skipped, 10) === 1 ? "red" : "green",
              cursor: "pointer",
              display: "inline-block",
            }}
          ></div>
        </Tooltip>
  
        <span
          style={{ cursor: "pointer", textDecoration: "underline" }}
          data-bs-toggle="modal"
          data-bs-target="#view_salary_details"
          onClick={() => {
            setSelectedEmployee(record); // Set the employee details in the parent component
            setIsModalVisible(true); // Trigger modal visibility
          }}
        >
          {text}
        </span>
      </div>
    ),
  },
  
  {
    title: 'Emp Code',
    dataIndex: 'empcode',
    key: 'name',
  },
  {
    title: 'Gross Salary',
    dataIndex: 'gross_salary',
    key: 'gross_salary',
    render: (value) => `₹${value.toFixed(2)}`,
  },
  {
    title: 'Deductions',
    dataIndex: 'deductions',
    key: 'deductions',
    render: (value) => `₹${value.toFixed(2)}`,
  },
  {
    title: 'Lop Days',
    dataIndex: 'lop_days',
    key: 'lop_days',
  },
  {
    title: 'Net Pay',
    key: 'net_pay',
    render: (_, record) => `₹${(record.gross_salary - record.deductions).toFixed(2)}`,
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (_, record) => (
      <div className="dropdown">
        <button
          className="btn btn-light"
          type="button"
          id={`dropdownMenuButton-${record.id}`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{
            padding: '5px 10px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <i className="las la-ellipsis-v"></i>
        </button>
        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${record.id}`}>
          {/* View Details Option */}
          <li>
            <a
              className="dropdown-item"
              data-bs-toggle="modal"
              data-bs-target="#view_salary_details"
              onClick={() => handleViewDetails(record)}
            >
              View Details
            </a>
          </li>
  
          <li>
            <a
              className="dropdown-item"
              onClick={() => generateSalarySlip(record)}
            >
              Salary Silip
            </a>
          </li>

          {/* Skip/Add to Payroll Option */}
          <li>
            <a
              className={`dropdown-item ${
                ['paid', 'approved'].includes(record.payroll_status) ? 'text-danger' : 'text-muted'
              }`}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (!['paid', 'approved'].includes(record.payroll_status)) {
                  toast.error('This action is only applicable for paid or approved payroll.');
                  return;
                }
                handleSkipFromPayroll(record); // Call your function
              }}
              style={{
                cursor: ['paid', 'approved'].includes(record.payroll_status) ? 'pointer' : 'not-allowed',
                pointerEvents: ['paid', 'approved'].includes(record.payroll_status) ? 'auto' : 'none',
              }}
            >
              {parseInt(record.is_skipped, 10) === 1 ? 'Add to Payroll' : 'Skip Employee'}
            </a>
          </li>
        </ul>
      </div>
      
    ),
  }
  
  
  
];



 // Define the function to handle skipping an employee from payroll
 const handleSkipFromPayroll = async (employee) => {
  try {
    const isCurrentlySkipped = parseInt(employee.is_skipped, 10) === 1;
    const actionText = isCurrentlySkipped
      ? "add this employee back to the payroll cycle"
      : "remove this employee from this payroll cycle";

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `This will ${actionText}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: isCurrentlySkipped ? "Yes, add back!" : "Yes, skip it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      await axios.post(
        `${apiUrl}/payroll/skip-employee`,
        {
          employee_id: employee.id,
          payroll_id: payrollData.payroll.payroll_id, // Ensure payroll ID is included
          is_skipped: isCurrentlySkipped ? 0 : 1, // Toggle skip state
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire(
        isCurrentlySkipped ? "Added Back!" : "Skipped!",
        `Employee has been ${isCurrentlySkipped ? "added back to" : "skipped from"} payroll.`,
        "success"
      );

      // Refresh payroll data after the action
      const response = await axios.get(`${apiUrl}/payroll/payroll-details`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPayrollData(response.data);
    }
  } catch (error) {
    console.error("Error handling skip/add action:", error);
    Swal.fire("Error", "Failed to update employee status. Please try again.", "error");
  }
};


const handleViewDetails = (employee) => {
  setSelectedEmployee({
    name: employee.name,
    empcode: employee.id,
    department_name: employee.department,
    date_of_joining: employee.joiningDate,
    department_name: employee.department_name || "Unknown", // Default if not provided
    date_of_joining: employee.date_of_joining || "N/A", // Default if not provided
    salary_breakdown: employee.salary_breakdown, // Use dynamic salary breakdown
  });
  setIsModalVisible(true);
};



     // Fetch Payroll Details
  useEffect(() => {
    const fetchPayrollDetails = async () => {
      try {
        const response = await axios.get(`${apiUrl}/payroll/payroll-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status === 'setting-pending') {
          toast.success('Payroll settings not found. Redirecting to settings...');
          navigate("/payroll-settings");

        } else if (response.data.status === 'no-payroll') {
          toast.success('No payroll data found. Redirecting to payroll overview...');
          navigate("/payroll-overview");

        } else {
          setPayrollData(response.data);
        }
      } catch (error) {
        console.error('Error fetching payroll details:', error);
        toast.error('Failed to fetch payroll details.');
      } finally {
        setLoading(false);
      }
    };

    fetchPayrollDetails();
  }, [apiUrl, token]);


  if (loading) {
    return (
      <div className="content container-fluid">
        <Spin size="large" style={{ display: 'block', margin: '50px auto' }} />
      </div>
    );
  }

  if (payrollData || !payrollData.employees) {
      return (
    <div className="page-wrapper">
      <div className="content container-fluid pb-0">



                <div className="page-header page-top-icons">
                  <div className="row align-items-center justify-content-between">
                  <div className="col-md-4" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Title level={3} style={{ marginBottom: 0, marginRight: "5px" }}>Run Payroll</Title>
                    <Badge
                      count={payrollData.payroll.payroll_status.toUpperCase()}
                      style={{
                        backgroundColor: "#52c41a",
                        fontSize: "12px",
                        height: "22px",
                        lineHeight: "22px",
                      }}
                    />



                  </div>

                  <div className="col-md-8 float-end ms-auto">
  <div
    className="d-flex justify-content-end align-items-center gap-2"
  
  >
    {/* Approve Payroll Button */}
    {payrollData?.payroll?.payroll_status === "draft" && (
      <Button
        type="primary"
        onClick={async () => {
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "This will approve the payroll.",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Yes, approve it!",
            cancelButtonText: "No, cancel!",
          });

          if (result.isConfirmed) {
            try {
              await axios.post(
                `${apiUrl}/payroll/approve/${payrollData.payroll.payroll_id}`,
                null,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              toast.success("Payroll approved successfully.");
              setPayrollData((prev) => ({
                ...prev,
                payroll: { ...prev.payroll, payroll_status: "approved" },
              }));
            } catch (error) {
              console.error("Error approving payroll:", error);
              toast.error("Failed to approve payroll.");
            }
          }
        }}
      >
        Approve Payroll
      </Button>
    )}

    {/* Make Payment Button */}
    {payrollData?.payroll?.payroll_status === "approved" && (
      <Button
        type="primary"
        onClick={async () => {
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Once you proceed, the payroll will be marked as paid and cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, make payment!",
            cancelButtonText: "Cancel",
          });

          if (result.isConfirmed) {
            try {
              await axios.post(
                `${apiUrl}/payroll/make-payment/${payrollData.payroll.payroll_id}`,
                null,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              toast.success("Payment processed successfully.");
              setPayrollData((prev) => ({
                ...prev,
                payroll: { ...prev.payroll, payroll_status: "paid" },
              }));
            } catch (error) {
              console.error("Error making payment:", error);
              toast.error("Failed to process payment. Please try again.");
            }
          }
        }}
      >
        Make Payment
      </Button>
    )}

    {/* Disabled Paid Button */}
    {payrollData?.payroll?.payroll_status === "paid" && (
      <Button type="primary">PAID</Button>
    )}

    {/* Export to Excel Button */}
    <Button
      type="primary"
      icon={<FileText size={16} style={{ marginRight: "5px" }} />}
      onClick={handleExportToExcel}
      style={{
        backgroundColor: "#28a745", // Green for Excel
        borderColor: "#28a745",
        color: "#fff",
      }}
    >
    </Button>

    {/* Export to PDF Button */}
    <Button
      type="primary"
      icon={<File size={16} style={{ marginRight: "5px" }} />}
      onClick={handleExportToPDF}
      style={{
        backgroundColor: "#d9534f", // Red for PDF
        borderColor: "#d9534f",
        color: "#fff",
      }}
    >
    </Button>

    {/* Dropdown Menu */}
    <div className="dropdown">
      <button
        className="btn btn-light"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          padding: "5px 10px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <i className="las la-ellipsis-v"></i>
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li>
          <a className="dropdown-item" href="#">
            Edit Payroll
          </a>
        </li>
        <li>
          <a className="dropdown-item" href="#">
            View Reports
          </a>
        </li>
        <li>
          <a
            className="dropdown-item text-danger"
            href="#"
            onClick={async () => {
              if (payrollData?.payroll?.payroll_status === "paid") {
                toast.error("Cannot delete a payroll that is already paid.");
                return;
              }

              const result = await Swal.fire({
                title: "Are you sure?",
                text: "This will permanently delete the payroll.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No, cancel!",
              });

              if (result.isConfirmed) {
                try {
                  await axios.delete(
                    `${apiUrl}/payroll/delete/${payrollData.payroll.payroll_id}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                  );
                  toast.success("Payroll deleted successfully.");
                  navigate("/payroll-overview");
                } catch (error) {
                  console.error("Error deleting payroll:", error);
                  toast.error("Failed to delete payroll.");
                }
              }
            }}
          >
            <i className="fa fa-trash m-r-5" /> Delete Payroll
          </a>
        </li>
      </ul>
    </div>

    {/* Refresh Icon */}
    <Link to="#" className="btn btn-link">
      <i className="las la-redo-alt" />
    </Link>

    {/* Expand Icon */}
    <Link to="#" className="btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
      <i className="las la-expand-arrows-alt" />
    </Link>
  </div>
</div>

                  </div>
                </div>
          
            {/* Alerts */}
           
      

            {/* Key Stats */}

            <Row gutter={[16, 16]}>
  {/* Period and Payroll Cost */}
  <Col span={8}>
  <Card
    style={{
      borderLeft: '4px solid #1890ff',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      height: '150px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      padding: '10px',
    }}
  >
    <Title level={5} style={{ marginBottom: '10px', fontWeight: 'bold' }}>
      <span style={{ fontWeight: 'normal', color: '#555', marginRight: '8px' }}>Period:</span>
      <span>
        {payrollData?.payroll?.payroll_status === "paid" && payrollData?.payroll?.payroll_paid_cycle
          ? new Date(
              parseInt(payrollData.payroll.payroll_paid_cycle.split('-')[1]), // Year
              parseInt(payrollData.payroll.payroll_paid_cycle.split('-')[0]) - 1 // Month (0-indexed)
            ).toLocaleString('default', { month: 'long', year: 'numeric' })
          : payrollData?.payroll?.payroll_month
          ? new Date(
              parseInt(payrollData.payroll.payroll_month.split('-')[1]), // Year
              parseInt(payrollData.payroll.payroll_month.split('-')[0]) - 1 // Month (0-indexed)
            ).toLocaleString('default', { month: 'long', year: 'numeric' })
          : "N/A"}
      </span>
      <span style={{ marginLeft: '12px', fontSize: '14px', fontWeight: 'normal', color: '#777' }}>
        ({payrollData?.payroll?.total_employees || "0"} Base Days)
      </span>
    </Title>

    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid #f0f0f0',
        paddingTop: '10px',
      }}
    >
      <div style={{ textAlign: 'left' }}>
        <Text style={{ fontSize: '14px', fontWeight: '500' }}>Payroll Cost</Text>
        <br />
        <Title level={5} style={{ fontSize: '21px', margin: 0, fontWeight: 'bold' }}>
          ₹{payrollData?.payroll?.total_salary?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </Title>
      </div>
      <div
        style={{
          borderLeft: '1px solid #f0f0f0',
          height: '50px',
          margin: '0 10px',
        }}
      />
      <div style={{ textAlign: 'right' }}>
        <Text style={{ fontSize: '14px', fontWeight: '500' }}>Employee Net Pay</Text>
        <br />
        <Title level={5} style={{ margin: 0, fontSize: '21px', fontWeight: 'bold' }}>
          ₹{(payrollData?.payroll?.total_salary - payrollData?.payroll?.total_deductions)?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </Title>
      </div>
    </div>
  </Card>
</Col>


  {/* Pay Day */}
  <Col span={8}>
  <Card
    style={{
      borderLeft: '4px solid #52c41a',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      height: '150px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      padding: '10px',
    }}
  >
<Text
  level={5}
  style={{
    marginBottom: 0,
    fontWeight: 'bold',
    fontSize: '14px',
  }}
  type="primary"
>
  {payrollData?.payroll?.payroll_status === "paid" ? "Paid On" : "Pay Day"}
</Text>

    <Title level={5} style={{ marginBottom: 0, fontWeight: 'bold' }}>
  {payrollData?.payroll?.payroll_status === "paid" && payrollData?.payroll?.payment_date
    ? new Date(payrollData.payroll.payment_date).toLocaleDateString('default', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : payrollData?.payroll?.pay_day || "N/A"}
</Title>

    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {/* Green Dot for Included Employees */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: 'green',
          }}
        ></div>
        <Text style={{ fontSize: '14px', fontWeight: '500' }}>
          {payrollData?.payroll?.total_employees || '0'} Employee
          {payrollData?.payroll?.total_employees > 1 ? 's' : ''}
        </Text>
      </div>
      {/* Red Dot for Skipped Employees */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: 'red',
          }}
        ></div>
        <Text style={{ fontSize: '14px', fontWeight: '500', color: 'red' }}>
          {payrollData?.employees?.filter((e) => parseInt(e.is_skipped, 10) === 1).length || 0} Employees skipped
        </Text>
      </div>
    </div>
    <span
  style={{
    display: 'block',
    marginBottom: '0px',
    marginTop: '10px',
    color: payrollData?.payroll?.days_difference < 0 ? '#1890ff' : '#ff4d4f',
    fontWeight: 'bold',
  }}
>
  {payrollData?.payroll?.payroll_status === "paid"
    ? `Next payroll is due to run after ${Math.abs(payrollData.payroll.days_difference)} days.`
    : payrollData?.payroll?.days_difference < 0
    ? `Payroll is scheduled to run in ${Math.abs(payrollData.payroll.days_difference)} days.`
    : `This payment is overdue by ${payrollData.payroll.days_difference} days.`}
</span>


  </Card>
</Col>




  {/* Taxes */}
  <Col span={8}>
    <Card
      style={{
        borderLeft: '4px solid #faad14',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        height: '150px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        padding: '10px',
      }}
    >
      <Text level={5} style={{ marginBottom: 0, fontWeight: 'bold' }} type="primary" style={{ fontSize: '14px' }}>

        Taxes and Deduction
      </Text>
      <Title level={5} style={{ marginBottom: '10px', fontSize: '24px', fontWeight: 'bold' }}>
        ₹{payrollData?.payroll?.total_deductions?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
      </Title>
      <div>

      </div>
      <div>
     
      </div>
    </Card>
  </Col>
</Row>




            {/* Tabs for Details */}
            <Tabs defaultActiveKey="employeeSummary" style={{ marginTop: '20px' }}>
              <TabPane tab="Employee Summary" key="employeeSummary">
              <Table
                  columns={columns}
                  dataSource={payrollData.employees}
                  rowClassName={(record) => (parseInt(record.is_skipped, 10) === 1 ? "skipped-row" : "")}

                  rowKey="id"
                  bordered
                />
             
              </TabPane>
              <TabPane tab="Taxes & Deductions" key="taxesDeductions">
                <Card
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <Text type="secondary">Details of taxes and deductions will appear here.</Text>
                </Card>
              </TabPane>
              <TabPane tab="Overall Insights" key="overallInsights">
                <Card
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <Text type="secondary">Overall payroll insights will be displayed here.</Text>
                </Card>
              </TabPane>
            </Tabs>
          
            <ViewSalaryModal
            isVisible={isModalVisible} // Pass visibility state to the modal
            employee={selectedEmployee}
            payrollStatus={payrollData?.payroll?.payroll_status} // Pass payroll status as a prop
            salaryHeads={[]}
            onDefineSalary={handleCloseModal}
          />



       
      </div>
    </div>
  );
};

}

export default PayrollPage;
